import type { EchainAccessoriesSlice, EchainAccessoriesSliceData } from '@hooks/states/echainAccessoriesSlice';
import { createEchainAccessoriesSlice } from '@hooks/states/echainAccessoriesSlice';
import React from 'react';
import type { StoreApi } from 'zustand';
import create from 'zustand';
import createContext from 'zustand/context';
import type { EchainConfigSlice, EchainConfigSliceData } from './echainConfigSlice';
import { createEchainConfigSlice } from './echainConfigSlice';
import type { EchainPartsListSlice, EchainPartsListSliceData } from './echainPartsListSlice';
import { createEchainPartsListSlice } from './echainPartsListSlice';

export type EchainProductStore = EchainPartsListSlice & EchainAccessoriesSlice & EchainConfigSlice;

export type EchainProductStoreInitialData = EchainPartsListSliceData &
  EchainAccessoriesSliceData &
  EchainConfigSliceData;

export const createStore = (initialData?: EchainProductStoreInitialData) =>
  create<EchainProductStore>((set, get) => ({
    ...createEchainPartsListSlice(set, get, initialData),
    ...createEchainAccessoriesSlice(set, get, initialData),
    ...createEchainConfigSlice(set, get, initialData),
  }));

const { Provider, useStore } = createContext<StoreApi<EchainProductStore>>();

export const useEchainProductStore = useStore;

type EchainProductStoreProviderProps = {
  initialData?: EchainProductStoreInitialData;
  children?: React.ReactNode;
};

export const EchainProductStoreProvider = ({ children, initialData }: EchainProductStoreProviderProps) => (
  <Provider createStore={() => createStore(initialData)}>{children}</Provider>
);
